import { createFileRoute } from '@tanstack/react-router';

import { RoleDashboard } from '@/features/dashboard/RoleDashboard';

export const Route = createFileRoute('/_authed/')({
  component: RoleDashboard,
});
